<template>
  <v-sheet color="bg1" height="100%" width="100%">
    <v-card
      height="100%"
      flat
      class="rounded-0 rounded-tl-lg pa-4 overflow-hidden"
      :loading="modelsLoading">
      <div
        class="pa-2 d-flex align-center"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Symbols</h3>
      </div>
      <div class="pa-4">
        <!--Folders List-->
        <AdminSymbolsFolder :key="folder.id" :folder="folder"></AdminSymbolsFolder>
        <!--Confirmation Messages-->
        <div class="info-section" style="align-items: center">
          <input
            type="file"
            webkitdirectory
            multiple
            style="display: none"
            id="browsePointCloudFile"
            @change="onPointCloudFileChanged($event)" />
          <progress
            style="width: 50%; height: 20px"
            v-if="isUploadingPointCloud"
            min="0"
            :max="maxProgress"
            step="1"
            :value="progress"></progress>
          <div v-if="isUploadingPointCloud">
            {{ progress }}/{{ maxProgress }} Files
            {{ isDeleting ? 'Deleted' : 'Uploaded' }}
          </div>
          <div style="display: flex; width: 100%; justify-content: center"></div>
        </div>
      </div>
    </v-card>
  </v-sheet>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
  import { getAllMarkupSymbols, saveMarkupSymbol } from '@Utils/mongoUtils';

  const ForgeMarkupSymbol = window.ForgeMarkupSymbol;
  export default {
    name: 'AdminSymbols',
    components: {
      AdminSymbolsFolder: () =>
        import('@/components/admin/components/symbols/adminSymbolsFolder.vue'),
    },
    props: ['modelsLoading'],
    data() {
      return {
        isExpanded: false,
        isUploadingPointCloud: false,
        progress: 0,
        maxProgress: 100,
        isDeleting: false,
        searchText: '',
        folderPath: '',
        itemsTree: [],
        folder: [],
      };
    },
    async mounted() {
      var allMarkupSymbols = await getAllMarkupSymbols();
      this.$store.commit('setMarkupSymbols', allMarkupSymbols);
      this.itemsTree = this.getSymbolsTree(allMarkupSymbols);
      this.folders = this.itemsTree.folders;
      this.folder = {
        name: 'Symbols',
        symbols: this.itemsTree.symbols,
        folders: this.folders,
        path: '',
        id: this.$store.state.forgeService.newGuid(),
      };
    },
    methods: {
      addNewSymbol(folder) {
        var _this = this;
        this.$store.dispatch({
          type: 'prompt_Forge_Extended',
          title: 'Add new Symbol',
          callback: (inputs) => {
            var name = inputs[0].trim();
            var svgText = inputs[1];
            var symbol = new ForgeMarkupSymbol();
            symbol.name = name;
            symbol.createDate = new Date().toDateString();
            symbol.userId = _this.$store.state.username;
            symbol.createdBy = _this.$store.state.username;
            symbol.svgText = svgText;
            symbol.folderPath = _this.folderPath;
            saveMarkupSymbol(symbol);
            _this.getCurrentNode().symbols.push(symbol);
          },
          input: {
            inputName: 'Name',
            inputValue: '',
          },
          extendedInput: {
            inputName: 'SVG Text',
            inputValue: '',
          },
        });
      },
      getSymbolsTree(symbols) {
        let tree = {
          name: '',
          symbols: [],
          folders: [],
        };
        for (let symbol of symbols) {
          if (!symbol.folderPath) tree.symbols.push(symbol);
          else {
            let folders = symbol.folderPath.split('/');
            let folderToAddInto = tree;
            let path = '';
            for (let name of folders) {
              path += path ? '/' + name : name;
              let folder = folderToAddInto.folders.find((o) => o.name == name);
              if (!folder) {
                folder = {
                  name: name,
                  symbols: [],
                  folders: [],
                  path: path,
                  id: this.$store.state.forgeService.newGuid(),
                };
                folderToAddInto.folders.push(folder);
              }
              folderToAddInto = folder;
            }
            folderToAddInto.symbols.push(symbol);
          }
        }
        return tree;
      },
      getCurrentNode() {
        let node = this.itemsTree;
        if (!this.folderPath) return node;
        let folders = this.folderPath.split('/');
        for (let folder of folders) {
          node = node.folders.find((o) => o.name == folder);
        }
        return node;
      },
      toggleExpandedFolder(path) {
        var _this = this;
        if (_this.folderPath === path) {
          //Navigate up
          var lastSlash = path.lastIndexOf('/');
          var parentPath = path.slice(0, lastSlash);
          _this.folderPath = parentPath;
        } else {
          _this.folderPath = path;
        }
      },
      toggleExpanded() {
        toggleExpandComponent(this);
      },
    },
  };
</script>
